import { render, staticRenderFns } from "./MenuBarClearButton.vue?vue&type=template&id=f6b6c0a0"
import script from "./MenuBarClearButton.vue?vue&type=script&lang=js"
export * from "./MenuBarClearButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports